import React from 'react'
import { Link } from "react-router-dom";
import File from "../img/intertek_2025.png"
import PDF_ONE from "../img/3602-7_ENG_Cedonia-Inc.pdf"
import File_Two from "../img/cgp.png"
import PDF_TWO from "../img/CG23543-Certificate-of-Registration.pdf"
import { FaCoins, FaCheckDouble, FaHandsHelping } from 'react-icons/fa'
import Video from "../img/Website_Video_Spin_2.mp4"

const qualityCards = [
    {
        icon: <FaHandsHelping size={"1.5em"} />,
        title: "Order Inspection at Multiple Stages",
        body: "Every component that we design or manufacture at Cedonia, goes through a formal quality inspection at various stages of the production process, including incoming order stage, in-process, and post-production.",
    },
    {
        icon: <FaCoins size={"1.5em"} />,
        title: "Investment in Testing and Measurement Tools",
        body: "We have made substantial investments in acquiring advanced tools and programs that help us with the quality control and inspection process. Our latest equipment, ZEISS CONTURA AND DURAMAX CMM enables precise checks and measurements while we test and inspect all the finished parts and products.",
    },
    {
        icon: <FaCheckDouble size={"1.5em"} />,
        title: "Upkeep of Machines and Equipment",
        body: "We have put in place a best-in-class maintenance and calibration program that checks whether our machines and equipment are performing as per the specified standards. We make sure that our facility runs effectively and efficiently, and is in top shape at all times.",
    },
];

const testimonials = [
    {
        image: "https://enginuityinc.ca/wp-content/uploads/2021/09/Enginuity-Headshot-Slaven-BW-2.jpg",
        quote: "Work with this company quite a bit, always fantastic to deal with. Open, friendly, and most of all, extremely high quality. A machine shop that you can hand jobs off to and not have to worry about them coming in off spec. I've used their 5-axis CNC services, plunge and wire EDM cutting, turning, and everything is always spot-on. Could recommend anytime.",
        name: "Slaven Prostran",
        role: "InvoDane Engineering, Toronto",
    },
    {
        image: "https://i1.rgstatic.net/ii/profile.image/299319002451970-1448374619467_Q512/Slobodan-Rancic.jpg",
        quote: "We have been working with Cedonia for almost 20 years in the production of our various complex prototypes, parts and sub-assemblies. They produce parts of excellent quality in the shortest time. Cedonia's technicians are true professionals, friendly and always ready to give their input in choosing the optimal design to simplify the manufacturing of our prototypes.",
        name: "Slobodan Rancic",
        role: "CFD Engineer, Fluid Pressure and Controls Group",
    },
];

export default function Quality() {
    return (
        <div className='bg-zinc-50 text-zinc-900'>
            <section className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
                <div className="mx-auto max-w-7xl text-center">
                    <p className='text-sm font-semibold uppercase tracking-[0.24em] text-red-600'>Quality</p>
                    <h1 className="mx-auto mt-4 max-w-5xl text-4xl font-extrabold tracking-tight text-zinc-950 sm:text-6xl">
                        Committed to <span className='text-red-600'>Quality</span> & <span className='text-red-600'>Customer Service</span>
                    </h1>
                    <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-zinc-600">
                        Our philosophy is simple. We deliver high-precision, high-quality custom machining requirements, in the lowest possible time, at the most competitive prices. Not only do we have the technical competence and machine capabilities to meet and exceed our client's expectations, but we also aim for the highest standards of quality and customer service.
                    </p>
                    <div className="mt-8">
                        <Link to="/contact" className="inline-flex rounded-md bg-red-600 px-6 py-3 text-base font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15">
                            Contact Now
                        </Link>
                    </div>
                </div>
            </section>

            <section className='bg-white px-4 pb-12 sm:px-6 lg:px-8'>
                <div className='mx-auto max-w-6xl overflow-hidden rounded-lg border border-zinc-200 bg-zinc-950 shadow-xl shadow-zinc-900/10'>
                    <video className='block aspect-video w-full object-cover' autoPlay loop muted defaultMuted playsInline>
                        <source src={Video}></source>
                    </video>
                </div>
            </section>

            <section className="px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
                <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-[1fr_0.9fr] lg:items-center">
                    <div>
                        <p className='text-sm font-semibold uppercase tracking-[0.22em] text-red-600'>Inspection standards</p>
                        <h2 className="mt-3 text-4xl font-extrabold tracking-tight text-zinc-950 sm:text-5xl">
                            Inspections are a Way of Life at Cedonia
                        </h2>
                        <p className="mt-5 text-lg leading-8 text-zinc-600">
                            We will never supply parts or products that we are not willing to buy ourselves. This is evident in our 28,000 square foot facility in Mississauga, Ontario, where every order passes through exacting standards of quality control.
                        </p>
                        <p className="mt-4 text-lg leading-8 text-zinc-600">
                            As an ISO-9001:2015 certified company, we take our quality checks very seriously.
                        </p>
                    </div>
                    <div className='grid gap-4 sm:grid-cols-2'>
                        <a href={PDF_ONE} target='PDF' className="flex min-h-[260px] items-center justify-center rounded-lg border border-zinc-200 bg-white p-6 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-red-100 hover:shadow-xl hover:shadow-zinc-900/10">
                            <img src={File} alt="Intertek certificate" className='max-h-56 w-full max-w-[220px] rounded-md object-contain' />
                        </a>
                        <a href={PDF_TWO} target='PDF' className="flex min-h-[260px] items-center justify-center rounded-lg border border-zinc-200 bg-white p-6 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-red-100 hover:shadow-xl hover:shadow-zinc-900/10">
                            <img src={File_Two} alt="CGP certificate" className='max-h-56 w-full max-w-[220px] rounded-md object-contain' />
                        </a>
                    </div>
                </div>
            </section>

            <section className='bg-white px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto grid max-w-7xl gap-5 lg:grid-cols-3'>
                    {qualityCards.map((card) => (
                        <article className='group rounded-lg border border-zinc-200 bg-white p-6 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-red-100 hover:shadow-xl hover:shadow-zinc-900/10 sm:p-8' key={card.title}>
                            <div className='flex h-14 w-14 items-center justify-center rounded-md bg-zinc-950 text-white transition duration-200 group-hover:bg-red-600'>
                                {card.icon}
                            </div>
                            <h3 className="mt-6 text-2xl font-bold tracking-tight text-zinc-950">{card.title}</h3>
                            <p className="mt-4 text-base leading-7 text-zinc-600">{card.body}</p>
                        </article>
                    ))}
                </div>
            </section>

            <section className='px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className="mx-auto max-w-7xl text-center">
                    <h2 className="text-4xl font-bold tracking-tight text-zinc-950">Your Preferred Partner for Custom Machining and Project Management</h2>
                    <p className="mx-auto mt-5 max-w-3xl text-lg leading-8 text-zinc-600">
                        At Cedonia, we are proud of our ability to deliver precise, defect-free parts and products across diverse, custom machining requirements, for complex, super-specialized businesses.
                    </p>
                    <p className="mx-auto mt-3 max-w-3xl text-lg leading-8 text-zinc-600">
                        Below are a few client testimonials that will throw light on our dedication to quality and customer service.
                    </p>
                </div>
                <div className='mx-auto mt-10 grid max-w-7xl gap-5 lg:grid-cols-2'>
                    {testimonials.map((item) => (
                        <article className='rounded-lg border border-zinc-200 bg-white p-6 shadow-sm sm:p-8' key={item.name}>
                            <div className='flex flex-col gap-6 sm:flex-row sm:items-center'>
                                <img alt={item.name} src={item.image} className='h-24 w-24 shrink-0 rounded-full object-cover grayscale' />
                                <div>
                                    <p className='text-lg leading-8 text-zinc-700'>"{item.quote}"</p>
                                    <div className='mt-5 flex flex-wrap items-center gap-2'>
                                        <span className='font-semibold text-red-600'>{item.name}</span>
                                        <span className='text-zinc-300'>/</span>
                                        <span className='text-sm text-zinc-500'>{item.role}</span>
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    )
}
